export default __webpack_public_path__ + "static/gloria-diaz-backyard-focus-b07bd119eb67d9ba791860f529845699.jpg";